<template>
  <div class="page">
    <div class="page-body">
      <transition name="page-transition">
        <keep-alive :include="['serveIndex', 'hospitalIndex', 'userIndex']">
          <router-view />
        </keep-alive>
      </transition>
    </div>
    <nav-bar></nav-bar>
  </div>
</template>

<script>
import NavBar from "./NavBar";
export default {
  name: "BasicLayout",
  components: {
    NavBar
  },

  data() {
    return {};
  },
  computed: {},

  created() {},
  methods: {}
};
</script>

<style lang="less">
.page-body {
  overflow: hidden;
  overflow-y: auto;
}
.page-transition-enter {
  transform: translateX(40%);
  opacity: 0;
}

.page-transition-enter-to {
  transform: translateX(0);
  opacity: 1;
}

.page-transition-enter-active {
  transition: ease 0.2s;
  display: inline-block;
}
</style>
